import { z } from 'zod';

export const changeZakatDatePostRequestSchema = z.object({ value: z.string() });
